import { type TextSerializer } from '@tiptap/react';
import { format } from 'date-fns';

import { type Attributes as ComboBoxAttributes } from './ComboBoxField';
import { type Attributes as DateFieldAttributes } from './DateField';
import { type Attributes as MentionAttributes } from './Mention';
import { type Attributes as NumberFieldAttributes } from './NumberField';
import { type Attributes as SelectAttributes } from './SelectField';
import { type TagAttributes } from './Tag';
import { type Attributes as TextFieldAttributes } from './TextField';

const textSerializers: Record<string, TextSerializer> = {
  comboBoxField: ({ node }) =>
    `{{${(node.attrs as ComboBoxAttributes).value ?? ''}}}`,
  dateField: ({ node }) => {
    const { value } = node.attrs as DateFieldAttributes;
    return `{{${value ? format(value, 'yyyy-MM-dd') : ''}}}`;
  },
  default: ({ node }) => node.textContent,
  mention: ({ node }) => `{{${(node.attrs as MentionAttributes).label}}}`,
  numberField: ({ node }) =>
    `{{${(node.attrs as NumberFieldAttributes).value}}}`,
  selectField: ({ node }) =>
    `{{${(node.attrs as SelectAttributes).value ?? ''}}}`,
  tag: ({ node }) => `{{${(node.attrs as TagAttributes).text}}}`,
  textField: ({ node }) => `{{${(node.attrs as TextFieldAttributes).value}}}`
};

export default textSerializers;
